import { useEffect, useState } from "react";

const NODES = ["Live Shows", "Host Mentions", "On-Site", "Email", "Social", "Web"];
const R = 118, CX = 160, CY = 160;
const pos = (i) => { const a = (-90 + i * 60) * (Math.PI / 180); return { x: CX + R * Math.cos(a), y: CY + R * Math.sin(a) }; };

export const ReachOrbit = () => (
  <div data-testid="reach-orbit" className="relative mx-auto w-full max-w-[400px]">
    <svg viewBox="0 0 320 320" className="h-auto w-full overflow-visible" role="img" aria-label="Your brand connected to live shows, host mentions, on-site materials, email, social and web">
      <circle cx={CX} cy={CY} r={R} fill="none" stroke="#149B9E" strokeWidth="1" strokeDasharray="3 7" opacity="0.35" className="orbit-ring" />
      {NODES.map((n, i) => { const p = pos(i); return <line key={n} x1={CX} y1={CY} x2={p.x} y2={p.y} stroke="#149B9E" strokeWidth="2" strokeDasharray="6 6" className="fl-link" style={{ "--i": i }} />; })}
      {NODES.map((n, i) => { const p = pos(i); return (
        <g key={n} className="fl-node" style={{ "--i": i }} data-testid={`reach-node-${i}`}>
          <circle cx={p.x} cy={p.y} r="9" fill="none" stroke="#FFC20E" strokeWidth="2" className="fl-ripple" />
          <circle cx={p.x} cy={p.y} r="8" fill="#FFC20E" stroke="#fff" strokeWidth="2.5" className="fl-dot" />
          <title>{n}</title>
        </g>
      ); })}
      <g className="brand-node">
        <circle cx={CX} cy={CY} r="46" fill="rgba(255,194,14,0.18)" className="brand-glow" />
        <circle cx={CX} cy={CY} r="34" fill="#111111" stroke="#FFC20E" strokeWidth="3" />
        <text x={CX} y={CY - 2} textAnchor="middle" fill="#fff" fontSize="11" fontWeight="700" letterSpacing="1.5">YOUR</text>
        <text x={CX} y={CY + 12} textAnchor="middle" fill="#FFC20E" fontSize="11" fontWeight="700" letterSpacing="1.5">BRAND</text>
      </g>
    </svg>
    <ul className="pointer-events-none absolute inset-0" aria-hidden>
      {NODES.map((n, i) => { const p = pos(i); const left = p.x >= CX; const edge = Math.abs(p.x - CX) < 1; return (
        <li key={n} className="fl-label absolute whitespace-nowrap rounded-full bg-white/95 px-2.5 py-1 text-[11px] font-semibold text-black shadow ring-1 ring-black/10"
          style={{ "--i": i, top: `${(p.y / 320) * 100}%`, transform: edge ? `translate(-50%, ${p.y < CY ? "-150%" : "50%"})` : "translateY(-50%)", ...(edge ? { left: `${(p.x / 320) * 100}%` } : left ? { left: `${(p.x / 320) * 100 + 5}%` } : { right: `${100 - (p.x / 320) * 100 + 5}%` }) }}>{n}</li>
      ); })}
    </ul>
  </div>
);

export const CountUpChip = ({ to = 405000, label = "confirmed annual live participants", testId = "hero-stat-chip" }) => {
  const [n, setN] = useState(to);
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const t0 = performance.now(), dur = 1800; let raf;
    const tick = (t) => { const p = Math.min(1, (t - t0) / dur); setN(Math.round(to * (1 - Math.pow(1 - p, 3)))); if (p < 1) raf = requestAnimationFrame(tick); };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [to]);
  return (
    <p data-testid={testId} className="hero-chip mt-6 inline-flex items-baseline gap-2 rounded-full bg-black px-5 py-2.5 text-white shadow-lg">
      <span className="font-display text-2xl text-en-yellow tabular-nums" aria-hidden>{n.toLocaleString()}</span>
      <span className="sr-only">{to.toLocaleString()}</span>
      <span className="text-sm text-white/80">{label}</span>
    </p>
  );
};
